import { render } from "./PropertiesView.vue?vue&type=template&id=17b55260&scoped=true"
import script from "./PropertiesView.vue?vue&type=script&lang=js"
export * from "./PropertiesView.vue?vue&type=script&lang=js"

import "./PropertiesView.vue?vue&type=style&index=0&id=17b55260&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b55260"]])

export default __exports__